export default __webpack_public_path__ + "static/media/hero_image.b333123d.png";